import { useNavigate } from 'react-router-dom';
import EditIcon from '../../../assets/icons/edit.svg?react';
import DeleteIcon from '../../../assets/icons/delete.svg?react';

const ChargerTableItem = ({idx, charger, onChargerDetail, stationInfo, drResourceInfo, isStationLoading, onDelete, onEdit}) => {
  const navigate = useNavigate();

  const handleRowClick = () => {
    // 상세페이지로 이동
    navigate(`./detail/${charger.ChargerSysId}`, { state: { from: 'list' } });
  };

  return (
    <tr key={charger.ChargerSysId} className='primary-table-item-clickable' onClick={handleRowClick}>
      <td className="charger-idx">{idx}</td>
      <td className={`charger-dr-resource ${drResourceInfo?.ResourceName ? '' : 'no-assigned'}`}>{
        isStationLoading ? (
          <span className="loading-text">로딩 중...</span>
        ) : stationInfo ? (
          drResourceInfo ? drResourceInfo.ResourceName : "미할당"
        ) : "미할당"
      }</td>
      <td className="charger-station-id">
        {isStationLoading ? (
          <span className="loading-text">로딩 중...</span>
        ) : stationInfo ? (
          stationInfo.CpoStationId || stationInfo.CpoStationId || charger.CpoStationId
        ) : (
          "-"
        )}
      </td>
      <td className="charger-station-name">{
        isStationLoading ? (
          <span className="loading-text">로딩 중...</span>
        ) : stationInfo ? (
          stationInfo.CpoStationName
        ) : "-"
      }</td>
      <td className="charger-station-address">{
        isStationLoading ? (
          <span className="loading-text">로딩 중...</span>
        ) : stationInfo ? (
          stationInfo.Address
        ) : "-"
      }</td>
      <td className="charger-id">{charger.CpoChargerId}</td>
      <td className="charger-type">{charger.ChargerCapacity}</td>
      
      <td className='button-container' onClick={(e) => e.stopPropagation()}>
        <div className='flex align-center gap-5'>
          <button className='btn icon-btn' onClick={(e) => {e.stopPropagation(); onEdit(charger, stationInfo)}}>
            <EditIcon color='var(--gray-600)'/>
          </button>
          <button className='btn icon-btn' onClick={(e) => {e.stopPropagation(); onDelete(charger, stationInfo)}}>
            <DeleteIcon color='var(--gray-600)'/>
          </button>
        </div>
      </td>
    </tr>
  )
}

export default ChargerTableItem